import { lazy } from 'react';

export const HeartWrapperLazy = lazy(
    () =>
        import(
            /* webpackChunkName: "HeartWrapper" */
            'dibs-portfolio-heart'
        )
);
